import React from 'react';
import { DatePicker as MuiDatePicker } from '@material-ui/pickers';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import IconButton from '@material-ui/core/IconButton';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { localeDateFormatMap } from 'config/date-picker';
import { i18n } from 'config/i18n';

/**
 * Shared DatePicker that takes care of date format based on the locale
 * It also positioning the datepicker based on the media query
 */
const DatePicker = ({ adornmentPosition, calendarDayTestIdPrefix, renderDay, ...otherProps }) => {
  const theme = useTheme();
  const lgMatches = useMediaQuery(theme.breakpoints.up('lg'));

  const renderDayWithTestId = calendarDayTestIdPrefix
    ? (day, selectedDate, isInCurrentMonth, dayComponent) => {
      const base = renderDay
        ? renderDay(day, selectedDate, isInCurrentMonth, dayComponent)
        : dayComponent;
      return React.cloneElement(base, {
        'data-testid': `${calendarDayTestIdPrefix}-${day.date()}`,
      });
    }
    : renderDay;

  return (
    <MuiDatePicker
      fullWidth
      autoOk
      variant={lgMatches ? 'inline' : 'dialog'}
      inputVariant="outlined"
      format={localeDateFormatMap[i18n.language]}
      margin="none"
      renderDay={renderDayWithTestId}
      InputProps={
        adornmentPosition == 'start'
          ? {
            startAdornment: (
              <IconButton>
                <DateRangeIcon />
              </IconButton>
            ),
          }
          : {
            endAdornment: (
              <IconButton>
                <DateRangeIcon />
              </IconButton>
            ),
          }
      }
      {...otherProps}
    />
  );
};

export default DatePicker;

DatePicker.propTypes = {

};
